// Loading FOUC
$(window).load(function () {
  setTimeout(function () {
    $("html").toggleClass("no-javascript js");
  }, 50);
});
